enum EmployeePremission {
  Prem_Employee_Update_Prem = 'Prem_Employee_Update_Prem',
  Prem_Employee_Update_Avatar = 'Prem_Employee_Update_Avatar',
  Prem_Employee_Update_Papers = 'Prem_Employee_Update_Papers',
  Prem_Employee_Update_EasyID = 'Prem_Employee_Update_EasyID',
  Prem_Employee_Update_Login_Data = 'Prem_Employee_Update_Login_Data',
  Prem_Employee_View_Paper_F = 'Prem_Employee_View_Paper_F',
  Prem_Employee_Download_Paper_F = 'Prem_Employee_Download_Paper_F',
  Prem_Employee_Delete_Paper = 'Prem_Employee_Delete_Paper',
  Prem_Employee_Add_Paper = 'Prem_Employee_Add_Paper',
  Prem_Employee_Create = 'Prem_Employee_Create',
  Prem_Employee_Update = 'Prem_Employee_Update',
  Prem_Employee_Update_Job = 'Prem_Employee_Update_Job',
  Prem_Employee_Get_ALL = 'Prem_Employee_Get_ALL',
  Prem_Employee_Get_ONE = 'Prem_Employee_Get_ONE',
  Prem_Employee_DELETE_ONE = 'Prem_Employee_DELETE_ONE',
  Prem_Employee_Update_Utils = 'Prem_Employee_Update_Utils',
  Prem_Employee_Emp_Lists = 'Prem_Employee_Emp_Lists',
  Prem_Employee_Department_Master = 'Prem_Employee_Department_Master',
  Prem_EmployeeCustomerMap = 'Prem_EmployeeCustomerMap',
  // Tele-Sales Client Mapping Permissions
  Prem_Tele_Sales_Clients_Map_Retail_Open = 'Prem_Tele-Sales-Clients-Map_Retail_open',
  Prem_Tele_Sales_Clients_Map_Retail_Edit = 'Prem_Tele-Sales-Clients-Map_Retail_Edit',
  Prem_Tele_Sales_Clients_Map_Retail_LockEdit = 'Prem_Tele-Sales-Clients-Map_Retail_LockEdit',
  Prem_Tele_Sales_Clients_WholeSaleMap_Open = 'Prem_Tele-Sales-Clients-WholeSaleMap_Open',
  Prem_Tele_Sales_Clients_WholeSaleMap_Edit = 'Prem_Tele-Sales-Clients-WholeSaleMap_Edit',
  Prem_Tele_Sales_Clients_WholeSaleMap_LockEdit = 'Prem_Tele-Sales-Clients-WholeSaleMap_LockEdit',
  // Employee Supervisor Management Permissions
  Prem_Employee_Supervisor_Read = 'Prem_Employee_Supervisor_Read',
  Prem_Employee_Supervisor_Edit = 'Prem_Employee_Supervisor_Edit',
  // CashBox Management Permissions
  Prem_CashBox_Management = 'Prem_CashBox_Management',
}

export default EmployeePremission;
